const pad = value => {
  const text = String(value)
  return text.length < 2 ? '0' + text : text
}

const parseLocalText = value => {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?)?$/.exec(value)
  if (!match) return null
  const year = Number(match[1]); const month = Number(match[2]); const day = Number(match[3])
  const hour = Number(match[4] || 0); const minute = Number(match[5] || 0); const second = Number(match[6] || 0)
  const millisecond = Number(((match[7] || '') + '000').slice(0, 3))
  const date = new Date(year, month - 1, day, hour, minute, second, millisecond)
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day &&
    date.getHours() === hour && date.getMinutes() === minute && date.getSeconds() === second ? date : null
}

export const parseServerDateTime = value => {
  if (value === null || value === undefined || value === '') return null
  if (Object.prototype.toString.call(value) === '[object Date]') return Number.isNaN(value.getTime()) ? null : new Date(value.getTime())
  const text = String(value).trim()
  const asmx = /^\/Date\((-?\d+)(?:[+-]\d{4})?\)\/$/.exec(text)
  if (asmx) {
    let timestamp = Number(asmx[1])
    if (Math.abs(timestamp) < 100000000000) timestamp *= 1000
    const result = new Date(timestamp)
    return Number.isNaN(result.getTime()) ? null : result
  }
  if (/^\d{4}-\d{2}-\d{2}(?:[ T]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?)?$/.test(text)) return parseLocalText(text)
  const result = new Date(text)
  return Number.isNaN(result.getTime()) ? null : result
}

export const parseAsmxDateTime = parseServerDateTime

export const formatLocalDateTime = (value, fallback = '') => {
  const date = parseServerDateTime(value)
  if (!date) return fallback
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export const formatDateOnly = (value, fallback = '') => {
  const date = parseServerDateTime(value)
  if (!date) return fallback
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

export const serializeLocalDateTime = value => value ? formatLocalDateTime(value, null) : null
export const serializeDateOnly = value => value ? formatDateOnly(value, null) : null
